import { render } from "./ScheduleTandingPage.vue?vue&type=template&id=60f1a3ec&scoped=true"
import script from "./ScheduleTandingPage.vue?vue&type=script&lang=js"
export * from "./ScheduleTandingPage.vue?vue&type=script&lang=js"

import "./ScheduleTandingPage.vue?vue&type=style&index=0&id=60f1a3ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60f1a3ec"]])

export default __exports__